import { useNavigate } from "react-router-dom";
import listStyles from "./ListStyles.module.css";
import classNames from "classnames";

function CommunityList({ nests, handleFunctions = {}, manageMode = false }) {
  const navigate = useNavigate();
  const { handleApprove = null, handleDelete = null } = handleFunctions;
  return (
    <>
      {nests?.map((nest) => {
        const isPending = nest.status === "pending";
        const handleApproveClick = async (e) => {
          e.stopPropagation();
          const confirmed = window.confirm("요청을 승인하시겠습니까?");
          if (!confirmed) return;
          const { code, msg } = await handleApprove(
            { community_id: nest.id },
            manageMode?.token
          );
          if (code < 300) {
            alert("커뮤니티 생성 요청이 승인되었습니다");
            window.location.reload();
          } else {
            alert(msg);
          }
        };
        const handleRefuseClick = async (e) => {
          e.stopPropagation();
          const confirmed = window.confirm("요청을 거절하시겠습니까?");
          if (!confirmed) return;
          const { code, msg } = await handleDelete(
            { community_id: nest.id },
            manageMode?.token
          );
          if (code < 300) {
            alert("커뮤니티 생성 요청이 거절되었습니다");
            window.location.reload();
          } else {
            alert(msg);
          }
        };
        const handleDeleteClick = async (e) => {
          e.stopPropagation();
          const confirmed = window.confirm("해당 커뮤니티를 삭제하시겠습니까?");
          if (!confirmed) return;
          const code = await handleDelete(
            { community_id: nest.id },
            manageMode?.token
          );
          if (code < 300) {
            alert(`${nest.name} 커뮤니티를 삭제했습니다`);
            window.location.reload();
          } else {
            alert("실패했습니다");
          }
        };
        return (
          <div key={nest.id} className={listStyles.innerBox}>
            <div
              className={classNames(
                listStyles.listElem,
                manageMode && listStyles.admin
              )}
              onClick={() => navigate(`/nest/${nest.id}`)}
            >
              <div className={listStyles.profile}>
                <img
                  src={nest.profile_image || nest.image}
                  className={listStyles.profileIMG}
                  alt="커뮤니티 이미지"
                />
                <h2>{`${nest.communityName || nest.name} (${(() => {
                  switch (nest.type) {
                    case "USER":
                      return "유저 커뮤니티";
                    case "EXPERT":
                      return "전문가 커뮤니티";
                    case "OFFICIAL":
                      return "공식 커뮤니티";
                    default:
                      return;
                  }
                })()})`}</h2>
              </div>
              <p>{nest.description}</p>
              {manageMode &&
                (isPending ? (
                  <div className={listStyles.buttonBox}>
                    <button
                      className={listStyles.button}
                      onClick={handleApproveClick}
                    >
                      <p>승인</p>
                    </button>
                    <button
                      className={listStyles.button}
                      onClick={handleRefuseClick}
                    >
                      <p>거절</p>
                    </button>
                  </div>
                ) : (
                  <div className={listStyles.buttonBox}>
                    <button
                      className={listStyles.button}
                      onClick={handleDeleteClick}
                    >
                      <p>삭제</p>
                    </button>
                  </div>
                ))}
            </div>
          </div>
        );
      })}
    </>
  );
}

export default CommunityList;
